module.exports = __webpack_public_path__ + "img/icon-time.3853a752.svg";